import { useReducer } from 'react'; 
import apiCall from '~/utils/apiCall';
import bridge from '~/utils/bridge';
import checkPhone from '~/utils/valid/check-phone';

const initailState = {
  q1: '',
  q2: '',
  q3: '',
  q4: '',
  q5: '',

  infoName: '',
  infoPhone: '',

  info1: '',
  info2: '',
  info3: '',
  
  check: false,
};

function reducer(state, { type, payload }) {
  const { name, value } = payload;
  switch (type) {
    case 'ONCHANGE_RADIO': 
      return {
        ...state,
        [name]: value
      };
    case 'ONCHANGE_CHECKBOX':
      return {
        ...state,
        [name] : !state[name]
      };
    //infoPhone창의 value값이 숫자가 아니면 return 아니면 값을 넣어주장   
    case 'ONCHANGE_INFO':
      return {
        ...state,
        [name]: value
      };
    default:
      return state;
  }
};

function useSurvey() {
  const [state, dispatch] = useReducer(reducer, initailState);
  const { q1, q2, q3, q4, q5, info1, info2, info3, infoName, infoPhone, check } = state;

  const onChangeToRadio = e => {
    const { name, value } = e.currentTarget;
    dispatch({
      type: 'ONCHANGE_RADIO',
      payload: {
        name,
        value,
      }
    });
  };

  function onChangeToInfo(e) {
    const regexNumber = /[^0-9]/g;
    const { name, value } = e.currentTarget;

    if (name === 'infoPhone' && !(!regexNumber.test(value) && value.length < 12)) {
      return;
    }
    dispatch({
      type:'ONCHANGE_INFO',
      payload: {
        name,
        value,
      }
    });
  };

  function onChangeToCheckbox(e) {
    //이걸 안 할 경우 q1의 value값인지 알 수가 없음. 그냥 value만 하고 있었음 
    const { name } = e.currentTarget;

    dispatch({
      type: 'ONCHANGE_CHECKBOX',
      payload: {
        name,
      }
    });
  };

  function validate() {
    if (q1 === '') {
      alert('1번 문항을 선택하세요');
      return false;

    } else if (q2 === '') {
      alert('2번 문항을 선택하세요');
      return false;

    } else if (q3 === '') { 
      alert('3번 문항을 선택하세요');
      return false;

    } else if (q4 === '') {
      alert('4번 문항을 선택하세요');
      return false;

    } else if (q5 === '') {
      alert('5번 문항을 선택하세요');
      return false;
    }

    if (infoName.trim() === '') {
      alert('이름을 입력해주세요');
      return false;
    }

    if (infoPhone === '') {
      alert('핸드폰 번호를 입력해주세요');
      return false;
    }

    const isValidPhone = checkPhone(infoPhone);
    if (isValidPhone) {
      alert(isValidPhone);
      return false;
    }
    
    if (info1 === '') {
      alert('연령대를 선택하세요');
      return false;

    } else if (info2 === '') {
      alert('성별을 선택하세요');
      return false;

    } else if (info3 === '') {
      alert('혼인 여부를 선택하세요');
      return false;
    }
    
    if(!check) {
      alert('동의 버튼을 확인하세요');
      return false;
    }

    return true;
  }

  function close() {
    bridge.ios(function (call) {
      console.log('ios');
      call.callHandler('ObjC Echo', {
       cmd: 'finishActivity',
     })
    })

    bridge.android(function (call) {
      console.log('android');
      call.finishActivity();
    });

    bridge.web(function () {
      console.log('web')
    });
  }

  /**
   * @description 참여 완료 클릭
   * api 통신
   */
  async function handelSubmit() {
    if (!validate()) return;

    try {
      const { q1, q2, q3, q4, q5, infoName, infoPhone, info1, info2, info3 } = state;
      const url = `/api/3/events/apply-20201120`;

      await apiCall.post(url, {
        question1: q1,
        question2: q2,
        question3: q3,
        question4: q4,
        question5: q5,
        name: infoName.trim(),
        phone: infoPhone,
        age: info1,
        gender: info2,
        wedding: info3,
      });

      alert('참여해주셔서 감사합니다.\n살고 싶은 방을 다방에서 확인해보세요.');
      close();

    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return {
    state,
    onChangeToRadio,
    onChangeToInfo,
    onChangeToCheckbox,
    handelSubmit,
  };
}

export default useSurvey;
